import React, { useState, useMemo } from 'react';
import { Image } from 'primereact/image';
import tep2 from "../../assets/img/tep2.jpeg";
import tep5 from "../../assets/img/tep5.jpeg";
import tep6 from "../../assets/img/tep6.jpeg";
import driver from "../../assets/img/driver.jpg";
import manifest from "../../assets/img/manifest.jpg";
import pod from "../../assets/img/pod.jpg";
import { useNavigate } from "react-router-dom";
import axios from 'axios'
import { ENDPOINTS } from '../../constants/endpoints';

export function Home(props) {

    const [activeTab, setActiveTab] = useState('booking');
    const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
    const [demoSubmitted, setDemoSubmitted] = useState(false);
    const [vehicleCount, setVehicleCount] = useState(350);
    const navigate = useNavigate();

    // Exact Pricing Tiers Data from Official Document (A$)
    const pricingTiers = [
        {
            id: 'essential',
            name: 'Essential',
            price: 85,
            includedVehicles: 75,
            extraRate: 2.00,
            badgeBg: 'bg-warning text-dark',
            description: 'For smaller fleets and everyday operations',
            usageText: 'Vehicle Usage up to 75',
            basePriceLabel: 'Base price: A$85.00'
        },
        {
            id: 'plus',
            name: 'Plus',
            price: 410,
            includedVehicles: 350,
            extraRate: 1.50,
            badgeBg: 'bg-secondary text-white',
            description: 'For growing businesses with increasing demands',
            usageText: 'Vehicle Usage up to 350',
            basePriceLabel: 'Base price: A$410.00'
        },
        {
            id: 'fleet',
            name: 'Fleet',
            price: 810,
            includedVehicles: 750,
            extraRate: 1.10,
            badgeBg: 'bg-primary text-white',
            description: 'For larger fleets and high-volume operations',
            usageText: 'Vehicle Usage up to 750',
            basePriceLabel: 'Base price: A$810.00',
            popular: true
        },
        {
            id: 'premium',
            name: 'Premium',
            price: 900,
            includedVehicles: 1000,
            extraRate: 0.90,
            badgeBg: 'bg-dark text-white',
            description: 'Advanced solutions for large-scale transport operations',
            usageText: 'Vehicle Usage 1000 and over',
            basePriceLabel: 'Base price: A$900.00'
        }
    ];

    // Dynamic Pricing Calculation
    const calculatedPlan = useMemo(() => {
        let tier = pricingTiers[0];
        if (vehicleCount > 750) {
            tier = pricingTiers[3];
        } else if (vehicleCount > 350) {
            tier = pricingTiers[2];
        } else if (vehicleCount > 75) {
            tier = pricingTiers[1];
        } else {
            tier = pricingTiers[0];
        }

        const extraVehicles = Math.max(0, vehicleCount - tier.includedVehicles);
        const extraCost = extraVehicles * tier.extraRate;
        const totalEstimate = tier.price + extraCost;

        return { tier, extraVehicles, extraCost, totalEstimate };
    }, [vehicleCount]);

    // Demo Form State
    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        phone: '',
        companyName: '',
        fleetSize: 'Plus Plan (Up to 350 Vehicles)',
        preferredDate: '',
        preferredTime: '10:00 AM'
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleDemoSubmit = (e) => {

        const emailData = {
            emailContent: `
            <!DOCTYPE html>
                <html>
                <head>
                <meta charset="utf-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <title>New Form Submission</title>
                </head>
                <body style="font-family: Arial, sans-serif; background-color: #f4f6f8; margin: 0; padding: 20px;">

                <div style="max-width: 600px; margin: 0 auto; background-color: #ffffff; border-radius: 8px; overflow: hidden; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                    
                    <!-- Header -->
                    <div style="background-color: #0056b3; color: #ffffff; padding: 20px; text-align: center;">
                    <h2 style="margin: 0; font-size: 20px;">New Inquiry Received</h2>
                    </div>

                    <!-- Body Content -->
                    <div style="padding: 24px;">
                    <p style="font-size: 14px; color: #555555; margin-top: 0;">You have received a new form submission with the following details:</p>
                    
                    <table style="width: 100%; border-collapse: collapse; margin-top: 15px;">
                        <tr>
                        <td style="padding: 10px; font-weight: bold; color: #333333; border-bottom: 1px solid #eeeeee; width: 35%;">Full Name:</td>
                        <td style="padding: 10px; color: #555555; border-bottom: 1px solid #eeeeee;">${formData.fullName}</td>
                        </tr>
                        <tr>
                        <td style="padding: 10px; font-weight: bold; color: #333333; border-bottom: 1px solid #eeeeee;">Email Address:</td>
                        <td style="padding: 10px; color: #555555; border-bottom: 1px solid #eeeeee;">
                            <a href="mailto:${formData.email}" style="color: #0056b3; text-decoration: none;">${formData.email}</a>
                        </td>
                        </tr>
                        <tr>
                        <td style="padding: 10px; font-weight: bold; color: #333333; border-bottom: 1px solid #eeeeee;">Phone Number:</td>
                        <td style="padding: 10px; color: #555555; border-bottom: 1px solid #eeeeee;">${formData.phone}</td>
                        </tr>
                        <tr>
                        <td style="padding: 10px; font-weight: bold; color: #333333; border-bottom: 1px solid #eeeeee;">Company Name:</td>
                        <td style="padding: 10px; color: #555555; border-bottom: 1px solid #eeeeee;">${formData.companyName}</td>
                        </tr>
                        <tr>
                        <td style="padding: 10px; font-weight: bold; color: #333333;">Selected Plan / Fleet Size:</td>
                        <td style="padding: 10px; color: #555555;">${formData.fleetSize}</td>
                        </tr>
                    </table>
                    </div>

                    <!-- Footer -->
                    <div style="background-color: #f8f9fa; padding: 15px; text-align: center; font-size: 12px; color: #888888; border-top: 1px solid #eeeeee;">
                    This email was automatically generated from your website form.
                    </div>

                </div>

                </body>
            </html>
            `,
            emailSubject: "Request for Demo Westoztransport App",
            emailRecipient: ['marksalvania103192@gmail.com', 'bookings@westoztransport.com']
        }

        // Send email if there are issues
        axios.post(props.APIUrl + ENDPOINTS.jobs_custom_email, emailData).then((emailres) => {
            if (emailres.data) {
                setTimeout(function () {
                    navigate("/pricing", { state: { toastMsg: "You have successfully sent message" } });
                    setDemoSubmitted(true);
                }, 1000);
            }
        });



    };

    const resetDemoForm = () => {
        setDemoSubmitted(false);
        setIsDemoModalOpen(false);
    };

    return (
        <div className="bg-white text-dark min-vh-100 font-sans ">

            {/* HERO SECTION */}
            <section className="py-5 bg-home-top">
            </section>
            <section className="py-5 bg-blue-gradient text-light border-bottom">
                <div className="container py-1 text-center">

                    <div className="d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill bg-primary-subtle text-primary fw-bold text-uppercase mb-3" style={{ fontSize: '11px' }}>
                        <span className="color-gradient">⚡ Smart Transport Management Software</span>
                    </div>

                    <h1 className="display-4 fw-black mb-3 lh-sm max-w-4xl mx-auto">
                        Built For Car Carriers, Dealerships & <br className="d-none d-md-inline" />
                        <span className="color-gradient">Vehicle Logistics Businesses</span>
                    </h1>

                    <p className="fs-5 fw-bold text-secondary mb-3">
                        All in one powerful, easy-to-use application.
                    </p>

                    <p className="max-w-2xl mx-auto mb-4 text-sm sm-text-base">
                        Automate multi-car bookings, route driver dispatches, collect photo digital PODs, and sync invoices directly with Xero & MYOB.
                    </p>

                    <div className="d-flex flex-column flex-sm-row justify-content-center gap-3 mb-4">
                        <button
                            id="book-demo"
                            onClick={() => setIsDemoModalOpen(true)}
                            className="btn rainbow-animated btn-lg fw-bold px-4 shadow"
                        >
                            Book Free Demo &rarr;
                        </button>
                        <a href="#pricing" className="btn btn-outline-light btn-lg fw-bold px-4">
                            View Pricing Tiers (From A$85)
                        </a>
                    </div>

                    <div className="d-flex flex-wrap justify-content-center gap-4 small fw-bold">
                        <div>✓ Plans From A$85/month</div>
                        <div>✓ Unlimited Drivers & Users</div>
                        <div>✓ Cancel Anytime • No Lock-in</div>
                    </div>

                    {/* SIMULATED APP PREVIEW DASHBOARD CARD */}

                    {/* MODERN INTERACTIVE DASHBOARD PREVIEW MOCKUP */}
                    <div className="mt-5 max-w-5xl mx-auto">
                        <div className="card border-0 shadow-soft rounded-4 overflow-hidden text-start">

                            {/* Browser/App Header */}
                            <div className="bg-slate-900 text-white px-4 py-3 d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center gap-2">
                                    <span className="rounded-circle bg-danger d-inline-block" style={{ width: 10, height: 10 }}></span>
                                    <span className="rounded-circle bg-warning d-inline-block" style={{ width: 10, height: 10 }}></span>
                                    <span className="rounded-circle bg-success d-inline-block" style={{ width: 10, height: 10 }}></span>
                                    <span className="ms-2 font-mono text-light text-xs">SER-ITY Operational Control Tower v2.4</span>
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                    <span className="badge rainbow-animated font-mono">LIVE DISPATCH</span>
                                </div>
                            </div>

                            {/* Dashboard Content */}
                            <div className="card-body bg-slate-50 p-4">

                                {/* Metric Summary Cards */}
                                <div className="row g-3 mb-4">
                                    <div className="col-md-3 col-6">
                                        <div className="bg-white p-3 rounded-3 border">
                                            <div className="text-muted text-uppercase fw-bold text-xs">Active Rigs</div>
                                            <div className="fs-4 fw-black text-slate-900 mt-1">14 Rigs</div>
                                            <div className="text-success text-xs fw-bold mt-1">● 100% Online</div>
                                        </div>
                                    </div>
                                    <div className="col-md-3 col-6">
                                        <div className="bg-white p-3 rounded-3 border">
                                            <div className="text-muted text-uppercase fw-bold text-xs">Vehicles Moved Today</div>
                                            <div className="fs-4 fw-black text-slate-900 mt-1">128 Units</div>
                                            <div className="text-primary text-xs fw-bold mt-1">↑ 14% vs Yesterday</div>
                                        </div>
                                    </div>
                                    <div className="col-md-3 col-6">
                                        <div className="bg-white p-3 rounded-3 border">
                                            <div className="text-muted text-uppercase fw-bold text-xs">Digital POD Rate</div>
                                            <div className="fs-4 fw-black text-slate-900 mt-1">100%</div>
                                            <div className="text-success text-xs fw-bold mt-1">Instant Photo Sign-off</div>
                                        </div>
                                    </div>
                                    <div className="col-md-3 col-6">
                                        <div className="bg-white p-3 rounded-3 border">
                                            <div className="text-muted text-uppercase fw-bold text-xs">Invoiced Today</div>
                                            <div className="fs-4 fw-black font-mono text-slate-900 mt-1">A$24,180</div>
                                            <div className="text-muted text-xs mt-1">Synced to Accounting</div>
                                        </div>
                                    </div>
                                </div>

                                {/* Dispatch Activity Table */}
                                <div className="bg-white border rounded-3 p-3">
                                    <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-2">
                                        <span className="fw-bold text-slate-900 text-xs text-uppercase">Live Transport Manifests</span>
                                        <span className="badge bg-slate-100 text-dark font-mono">3 Jobs Pending Pickup</span>
                                    </div>

                                    <div className="table-responsive">
                                        <table className="table table-hover align-middle text-xs mb-0">
                                            <thead className="table-light">
                                                <tr>
                                                    <th>JOB ID</th>
                                                    <th>VEHICLES / CARGO</th>
                                                    <th>PICKUP &rarr; DROPOFF</th>
                                                    <th>ASSIGNED DRIVER</th>
                                                    <th>POD & INVOICE</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="fw-bold font-mono text-primary">#SR-9041</td>
                                                    <td className="fw-bold">4x Fleet Sedans</td>
                                                    <td className="text-muted">Port Terminal &rarr; City Motors</td>
                                                    <td>Mike S. (Rig 04)</td>
                                                    <td><span className="badge bg-success">✓ Signed & Invoiced</span></td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold font-mono text-primary">#SR-9042</td>
                                                    <td className="fw-bold">6x Commercial Utes</td>
                                                    <td className="text-muted">Depot &rarr; West Auction Yard</td>
                                                    <td>David K. (Rig 01)</td>
                                                    <td><span className="badge bg-primary">⏱ In Transit (GPS Active)</span></td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold font-mono text-primary">#SR-9043</td>
                                                    <td className="fw-bold">2x Luxury Electric SUVs</td>
                                                    <td className="text-muted">Interstate Hub &rarr; Dealership</td>
                                                    <td>Chris P. (Rig 08)</td>
                                                    <td><span className="badge bg-warning text-dark">📷 Photo Inspection Done</span></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* KEY FEATURES SHOWCASE - INTERACTIVE BOOTSTRAP TABS */}
            <section id="features" className="py-5 bg-white border-bottom">
                <div className="container py-4">

                    <div className="text-center max-w-3xl mx-auto mb-5">
                        <span className="text-uppercase color-gradient fw-bold text-xs tracking-wider">Four Pillars of Efficiency</span>
                        <h2 className="fs-1 fw-black text-slate-900">Key Platform Capabilities</h2>
                        <p className="text-muted">Everything required to manage transport, safeguard vehicles, and protect profit margins.</p>
                    </div>

                    {/* Nav Pills Switcher */}
                    <ul className="nav nav-pills justify-content-center gap-2 mb-4">
                        {[
                            { id: 'booking', label: '1. Smart Booking' },
                            { id: 'driver', label: '2. Driver Management' },
                            { id: 'pod', label: '3. Digital PODs' },
                            { id: 'invoicing', label: '4. Invoicing Integration' },
                        ].map((tab) => (
                            <li className="nav-item" key={tab.id}>
                                <button
                                    onClick={() => setActiveTab(tab.id)}
                                    className={`nav-link fw-bold px-4 py-2.5 rounded-3 ${activeTab === tab.id ? 'active bg-primary shadow-sm' : 'text-dark bg-slate-100'
                                        }`}
                                >
                                    {tab.label}
                                </button>
                            </li>
                        ))}
                    </ul>

                    {/* Tab Content Box */}
                    <div className="card border shadow-soft rounded-4 p-4 p-md-5 bg-slate-50">
                        {activeTab === 'booking' && (
                            <div className="row align-items-center g-4">
                                <div className="col-md-6">
                                    <span className="badge bg-primary-subtle color-gradient text-uppercase font-mono mb-2">Pillar 01</span>
                                    <h3 className="fs-2 fw-black text-slate-900">Smart Booking & Dispatch</h3>
                                    <p className="text-muted leading-relaxed">
                                        Automate job creation, decode vehicle VIN barcodes, calculate truck deck limits, and schedule multi-car pickups seamlessly.
                                    </p>
                                    <ul className="list-unstyled space-y-2 text-slate-800 fw-semibold text-sm">
                                        <li className="mb-2">✔ <strong>Automated VIN Decoding:</strong> Instant vehicle specs and weight/height allocations.</li>
                                        <li className="mb-2">✔ <strong>Multi-Drop Load Optimization:</strong> Group dealership drops along carrier routes.</li>
                                        <li className="mb-2">✔ <strong>Customer Booking Portal:</strong> Allow dealership partners to submit movement requests directly.</li>
                                    </ul>
                                </div>
                                <div className="col-md-6">
                                    <div className="bg-white p-4 rounded-3 border shadow-sm">
                                        <Image src={manifest} alt="Image" width="100%" preview />
                                    </div>
                                </div>
                            </div>
                        )}

                        {activeTab === 'driver' && (
                            <div className="row align-items-center g-4">
                                <div className="col-md-6">
                                    <span className="badge bg-primary-subtle color-gradient text-uppercase font-mono mb-2">Pillar 02</span>
                                    <h3 className="fs-2 fw-black text-slate-900">Driver Management & GPS</h3>
                                    <p className="text-muted leading-relaxed">
                                        Equip drivers with a simple mobile app (iOS & Android) that guides job ordering, turn-by-turn routing, and live status updates.
                                    </p>
                                    <ul className="list-unstyled text-slate-800 fw-semibold text-sm">
                                        <li className="mb-2">✔ <strong>Native Mobile Driver App:</strong> Simple job sequencing, maps, and offline support.</li>
                                        <li className="mb-2">✔ <strong>Real-Time Telematics:</strong> Monitor live truck locations and pickup status on an interactive map.</li>
                                        <li className="mb-2">✔ <strong>Automated ETA Notifications:</strong> Send automated updates to dealership dropoff managers.</li>
                                    </ul>
                                </div>
                                <div className="col-md-6">
                                    <div className="bg-white p-4 rounded-3 border shadow-sm">
                                        <Image src={driver} alt="Image" width="100%" preview />
                                    </div>
                                </div>
                            </div>
                        )}

                        {activeTab === 'pod' && (
                            <div className="row align-items-center g-4">
                                <div className="col-md-6">
                                    <span className="badge bg-primary-subtle color-gradient text-uppercase font-mono mb-2">Pillar 03</span>
                                    <h3 className="fs-2 fw-black text-slate-900">Digital Proof of Delivery (POD)</h3>
                                    <p className="text-muted leading-relaxed">
                                        Protect your business against false damage claims. Drivers complete high-resolution 4-point photo condition reports and collect electronic signatures.
                                    </p>
                                    <ul className="list-unstyled text-slate-800 fw-semibold text-sm">
                                        <li className="mb-2">✔ <strong>4-Point Photo Inspection:</strong> Capture pre-existing damage or scratches prior to loading.</li>
                                        <li className="mb-2">✔ <strong>Sign-on-Glass Capture:</strong> Receivers sign directly on driver mobile screens.</li>
                                        <li className="mb-2">✔ <strong>Instant PDF Receipts:</strong> Digital POD emails immediately upon delivery completion.</li>
                                    </ul>
                                </div>
                                <div className="col-md-6">
                                    <div className="bg-white p-4 rounded-3 border shadow-sm align-items-center d-flex justify-content-center text-center">
                                        <Image src={pod} alt="Image" width="30%" preview />
                                    </div>
                                </div>
                            </div>
                        )}

                        {activeTab === 'invoicing' && (
                            <div className="row align-items-center g-4">
                                <div className="col-md-6">
                                    <span className="badge bg-primary-subtle color-gradient text-uppercase font-mono mb-2">Pillar 04</span>
                                    <h3 className="fs-2 fw-black text-slate-900">Invoicing & Accounting Sync</h3>
                                    <p className="text-muted leading-relaxed">
                                        Accelerate cashflow. The moment a digital POD is signed, an itemized invoice is created and synced directly with your ledger.
                                    </p>
                                    <ul className="list-unstyled text-slate-800 fw-semibold text-sm">
                                        <li className="mb-2">✔ <strong>Direct Xero, MYOB & QuickBooks Sync:</strong> Eliminates manual data re-entry.</li>
                                        <li className="mb-2">✔ <strong>Automated Toll & Fuel Surcharges:</strong> Automatically apply extra levies or wait times.</li>
                                        <li className="mb-2">✔ <strong>Faster Billing Cycles:</strong> Cut administrative billing delay down to zero minutes.</li>
                                    </ul>
                                </div>
                                <div className="col-md-6">
                                    <div className="bg-white p-4 rounded-3 border shadow-sm">
                                        <div className="text-uppercase text-muted fw-bold text-xs mb-3">Accounting Connections</div>
                                        <div className="d-flex flex-column gap-2 text-xs fw-bold">
                                            <div className="p-2.5 bg-slate-50 border rounded d-flex justify-content-between align-items-center">
                                                <span>Xero Accounting</span>
                                                <span className="badge bg-success">Sync Active</span>
                                            </div>
                                            <div className="p-2.5 bg-slate-50 border rounded d-flex justify-content-between align-items-center">
                                                <span>MYOB AccountRight</span>
                                                <span className="badge bg-success">Sync Active</span>
                                            </div>
                                            <div className="p-2.5 bg-slate-50 border rounded d-flex justify-content-between align-items-center">
                                                <span>QuickBooks Online</span>
                                                <span className="badge bg-success">Sync Active</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>

                </div>
            </section>

            {/* EXACT OFFICIAL PRICING TIERS SECTION (RECREATED FROM PDF) */}
            <section id="pricing" className="py-5 bg-blue-gradient text-light">
                <div className="container py-4">

                    <div className="text-center max-w-3xl mx-auto mb-5">
                        <span className="text-uppercase color-gradient fw-bold text-xs tracking-wider">Official Pricing Schedule</span>
                        <h2 className="fs-1 fw-black">Simple & Transparent Pricing</h2>
                        <p className="text-secondary">All prices listed in Australian Dollars (A$). Fixed base prices with predictable scaling.</p>
                    </div>

                    <div className="row g-4">
                        {pricingTiers.map((tier) => (
                            <div key={tier.id} className="col-md-6 col-lg-3">
                                <div className={`card h-100 border-2 rounded-4 shadow-sm hover-shadow transition ${tier.popular ? 'border-primary ring-2 ring-primary' : 'border-slate-200'}`}>

                                    {tier.popular && (
                                        <div className="bg-primary text-white text-uppercase font-mono text-center py-1 fw-bold text-xs rounded-top-4">
                                            Most Popular
                                        </div>
                                    )}

                                    <div className="card-body p-4 d-flex flex-column justify-content-between text-center">
                                        <div>
                                            <h3 className="fs-3 fw-black text-slate-900 mb-1">{tier.name}</h3>
                                            <div className="fs-2 fw-black text-slate-900 font-mono my-2">
                                                A${tier.price}<span className="fs-6 font-sans text-muted fw-bold">/mo</span>
                                            </div>
                                            <span className="badge bg-slate-100 text-dark fw-bold mb-3">Fixed Price</span>

                                            <p className="text-muted text-xs mb-4 min-h-36">
                                                {tier.description}
                                            </p>

                                            <div className="border-top pt-3 text-start text-xs space-y-2">
                                                <div className="mb-2">
                                                    <strong className="text-slate-900">✓ {tier.includedVehicles} vehicles</strong> included
                                                </div>
                                                <div className="mb-3 text-muted">
                                                    <strong>✓ A${tier.extraRate.toFixed(2)}/vehicle</strong> for additional usage
                                                </div>
                                                <div className="p-2 bg-slate-50 rounded border text-muted">
                                                    <div className="fw-bold text-slate-800">{tier.usageText}</div>
                                                    <div className="text-muted">{tier.basePriceLabel}</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="mt-4 pt-3 border-top">
                                            <div className="fs-4 fw-black text-slate-900 font-mono mb-2">
                                                A${tier.price}.00
                                            </div>
                                            <button
                                                onClick={() => {
                                                    setFormData(prev => ({ ...prev, fleetSize: `${tier.name} Plan (A$${tier.price}/mo)` }));
                                                    setIsDemoModalOpen(true);
                                                }}
                                                className={`btn w-100 fw-bold rounded-3 ${tier.popular ? 'rainbow-animated shadow' : 'btn-dark'}`}
                                            >
                                                Select {tier.name}
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </section>

            {/* INTERACTIVE FLEET COST ESTIMATOR */}
            <section id="calculator" className="py-5 bg-slate-50 border-bottom">
                <div className="container py-4">

                    <div className="text-center max-w-3xl mx-auto mb-4">
                        <span className="badge bg-primary-subtle color-gradient fw-bold text-uppercase mb-2">Interactive Estimator</span>
                        <h2 className="fs-1 fw-black text-slate-900">Calculate Your Fleet Cost</h2>
                        <p className="text-muted">Slide to your estimated monthly vehicle movement volume to preview your recommended tier.</p>
                    </div>

                    <div className="max-w-3xl mx-auto bg-white p-4 p-md-5 rounded-4 border shadow-sm">

                        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center gap-2 mb-3">
                            <label className="fw-bold text-slate-800">Estimated Monthly Vehicle Movements:</label>
                            <div className="fs-2 fw-black text-primary font-mono">
                                {vehicleCount} <span className="fs-6 text-muted font-sans">Vehicles / mo</span>
                            </div>
                        </div>

                        <input
                            type="range"
                            className="form-range mb-2"
                            min="10"
                            max="1500"
                            step="10"
                            value={vehicleCount}
                            onChange={(e) => setVehicleCount(Number(e.target.value))}
                        />

                        <div className="d-flex justify-content-between font-mono text-muted text-xs mb-4">
                            <span>10 (Essential)</span>
                            <span>350 (Plus)</span>
                            <span>750 (Fleet)</span>
                            <span>1000+ (Premium)</span>
                        </div>

                        {/* Dynamic Calculation Summary */}
                        <div className="row g-3 p-4 bg-slate-50 rounded-3 border align-items-center">
                            <div className="col-md-5">
                                <div className="text-uppercase text-muted fw-bold text-xs">Recommended Plan</div>
                                <div className="fs-3 fw-black text-slate-900 mt-1">
                                    {calculatedPlan.tier.name}
                                </div>
                                <div className="text-muted text-xs mt-1">{calculatedPlan.tier.description}</div>
                            </div>

                            <div className="col-md-3">
                                <div className="text-uppercase text-muted fw-bold text-xs">Allowance</div>
                                <div className="fw-bold text-slate-800 mt-1 text-sm">
                                    {calculatedPlan.tier.includedVehicles} Included
                                </div>
                                <div className="text-xs text-muted mt-1">
                                    {calculatedPlan.extraVehicles > 0 ? (
                                        <span className="text-primary font-bold">+{calculatedPlan.extraVehicles} extra @ A${calculatedPlan.tier.extraRate.toFixed(2)}</span>
                                    ) : (
                                        <span className="text-success font-bold">Standard Allowance</span>
                                    )}
                                </div>
                            </div>

                            <div className="col-md-4 text-md-end border-top border-md-0 pt-3 pt-md-0">
                                <div className="text-uppercase text-muted fw-bold text-xs">Estimated Monthly</div>
                                <div className="fs-2 fw-black text-slate-900 font-mono">
                                    A${calculatedPlan.totalEstimate.toFixed(2)}
                                </div>
                                <button
                                    onClick={() => setIsDemoModalOpen(true)}
                                    className="btn rainbow-animated btn-sm fw-bold mt-2 w-100"
                                >
                                    Book Demo &rarr;
                                </button>
                            </div>
                        </div>

                    </div>

                </div>
            </section>





            {/* FOOTER CALL TO ACTION */}
            <section className="py-5 bg-blue-gradient text-white text-center">
                <div className="container py-4">
                    <h2 className="display-6 fw-black mb-3">Ready To Simplify Transport Management?</h2>
                    <p className="text-light max-w-2xl mx-auto mb-4 text-sm sm-text-base opacity-75">
                        Book a complimentary live walkthrough with our team to see how SER-ITY optimizes vehicle moves.
                    </p>
                    <button
                        onClick={() => setIsDemoModalOpen(true)}
                        className="btn rainbow-animated btn-lg fw-bold px-5 shadow-lg"
                    >
                        Book Free Demo Now &rarr;
                    </button>
                </div>
            </section>

            {/* TARGET INDUSTRY SOLUTIONS */}
            <section id="solutions" className="py-5 bg-slate-50 border-top">
                <div className="container py-4">
                    <div className="text-center max-w-3xl mx-auto mb-5">
                        <span className="text-uppercase color-gradient fw-bold text-xs tracking-wider">Targeted Solutions</span>
                        <h2 className="fs-1 fw-black text-slate-900">Built For Your Logistics Niche</h2>
                    </div>

                    <div className="row g-4">
                        <div className="col-md-4">
                            <div className="card h-100 border p-4 rounded-4 bg-white shadow-sm">
                                <h3 className="fs-4 fw-bold text-slate-900 mb-2">Car Carriers</h3>
                                <p className="text-muted text-xs leading-relaxed">
                                    Single-rig operators to multi-deck carrier fleets. Optimize deck loading, monitor driver locations live, and automate job dispatches.
                                </p>
                                <ul className="text-xs fw-semibold text-slate-800 ps-3 mt-auto">
                                    <li className="mb-1">Deck-space fit calculations</li>
                                    <li>Live driver GPS telematics</li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card h-100 border p-4 rounded-4 bg-white shadow-sm">
                                <h3 className="fs-4 fw-bold text-slate-900 mb-2">Car Dealerships</h3>
                                <p className="text-muted text-xs leading-relaxed">
                                    Multi-site dealership groups managing inter-branch transfers and customer home deliveries with full time-stamped tracking.
                                </p>
                                <ul className="text-xs fw-semibold text-slate-800 ps-3 mt-auto">
                                    <li className="mb-1">Inter-branch move scheduling</li>
                                    <li>Digital condition logs at receipt</li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card h-100 border p-4 rounded-4 bg-white shadow-sm">
                                <h3 className="fs-4 fw-bold text-slate-900 mb-2">Vehicle Logistics & Auctions</h3>
                                <p className="text-muted text-xs leading-relaxed">
                                    High-volume reconditioning centers and auto auction networks requiring rapid VIN barcode intake and auto-generated billing ledgers.
                                </p>
                                <ul className="text-xs fw-semibold text-slate-800 ps-3 mt-auto">
                                    <li className="mb-1">Bulk VIN barcode intake</li>
                                    <li>Instant Xero & MYOB invoice sync</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* DEMO BOOKING MODAL */}
            {isDemoModalOpen && (
                <div className="modal d-block bg-slate-900 bg-opacity-75 backdrop-blur align-items-center justify-content-center" tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content rounded-4 border-0 shadow-lg p-3">

                            <div className="modal-header border-0 pb-0">
                                <h5 className="modal-title fw-black text-slate-900">
                                    {!demoSubmitted ? 'Schedule Your Free Demo' : 'Demo Scheduled!'}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={resetDemoForm}
                                ></button>
                            </div>

                            <div className="modal-body">
                                {!demoSubmitted ? (
                                    <div>
                                        <p className="text-muted text-xs mb-3">
                                            Experience how SER-ITY simplifies bookings, digital PODs, and accounting integration.
                                        </p>

                                        <div className="mb-3">
                                            <label className="form-label fw-bold text-xs">Full Name *</label>
                                            <input
                                                type="text"
                                                name="fullName"
                                                required
                                                value={formData.fullName}
                                                onChange={handleInputChange}
                                                className="form-control form-control-sm"
                                                placeholder="e.g. David Miller"
                                            />
                                        </div>

                                        <div className="row g-2 mb-3">
                                            <div className="col-6">
                                                <label className="form-label fw-bold text-xs">Email *</label>
                                                <input
                                                    type="email"
                                                    name="email"
                                                    required
                                                    value={formData.email}
                                                    onChange={handleInputChange}
                                                    className="form-control form-control-sm"
                                                    placeholder="david@transport.com"
                                                />
                                            </div>
                                            <div className="col-6">
                                                <label className="form-label fw-bold text-xs">Phone *</label>
                                                <input
                                                    type="tel"
                                                    name="phone"
                                                    required
                                                    value={formData.phone}
                                                    onChange={handleInputChange}
                                                    className="form-control form-control-sm"
                                                    placeholder="+61 400 000 000"
                                                />
                                            </div>
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label fw-bold text-xs">Company Name</label>
                                            <input
                                                type="text"
                                                name="companyName"
                                                value={formData.companyName}
                                                onChange={handleInputChange}
                                                className="form-control form-control-sm"
                                                placeholder="Apex Car Transport"
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label fw-bold text-xs">Interested Tier</label>
                                            <select
                                                name="fleetSize"
                                                value={formData.fleetSize}
                                                onChange={handleInputChange}
                                                className="form-select form-select-sm font-mono"
                                            >
                                                <option value="Essential Plan (Up to 75 Vehicles)">Essential — A$85/mo (75 vehicles)</option>
                                                <option value="Plus Plan (Up to 350 Vehicles)">Plus — A$410/mo (350 vehicles)</option>
                                                <option value="Fleet Plan (Up to 750 Vehicles)">Fleet — A$810/mo (750 vehicles)</option>
                                                <option value="Premium Plan (1000+ Vehicles)">Premium — A$900/mo (1000+ vehicles)</option>
                                            </select>
                                        </div>

                                        <button type="button" onClick={(e) => { handleDemoSubmit() }} className="btn btn-primary w-100 fw-bold py-2.5 mt-2">
                                            Confirm Demo Request
                                        </button>

                                        <p className="text-center text-muted text-xs mt-2 mb-0">
                                            🔒 No credit card required. Fast 20-minute live demonstration.
                                        </p>
                                    </div>
                                ) : (
                                    <div className="text-center py-4">
                                        <div className="fs-1 text-success mb-2">✓</div>
                                        <h4 className="fw-bold text-slate-900">Thank You, {formData.fullName}!</h4>
                                        <p className="text-muted text-xs mt-2">
                                            Your demo request has been received. Our team will contact you shortly via email ({formData.email}) to confirm your calendar booking.
                                        </p>
                                        <button onClick={resetDemoForm} className="btn btn-dark fw-bold btn-sm mt-3 px-4">
                                            Close Window
                                        </button>
                                    </div>
                                )}
                            </div>

                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}